import { render, staticRenderFns } from "./monitorItem.vue?vue&type=template&id=28623cbc&scoped=true&"
import script from "./monitorItem.vue?vue&type=script&lang=js&"
export * from "./monitorItem.vue?vue&type=script&lang=js&"
import style0 from "./monitorItem.vue?vue&type=style&index=0&id=28623cbc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28623cbc",
  null
  
)

export default component.exports